import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router";
import { getIntegratorCompanies } from "actions/integrators/integrators";
import styles from "styles";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
} from "material-ui/Table";
import TextField from "material-ui/TextField";
import Pagination from "components/Libs/Pagination";
import AutoComplete from "material-ui/AutoComplete";

import CompanyRow from "./CompanyRow";
import companyUser from "reducers/integrators/user";
export class IntegratorCompaniesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      rowsPerPage: [25, 50, 100],
      autocomplete: [],
    };
    this.updateFilter = this.updateFilter.bind(this);
    this.updateRows = this.updateRows.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.companies !== this.props.companies) {
      const autocomplete = nextProps.companies
        .map(
          (c) =>
            `${c.name.toLowerCase()} ${c.owner.email.toLowerCase()} ${c.members.map(
              (m) => m.email.toLowerCase()
            )}`
        )
        .join(" ")
        .split(" ");
      this.setState({
        autocomplete,
      });
    }
  }

  updateFilter(value) {
    this.setState({
      filter: value,
    });
  }

  updateRows(state) {
    const { getIntegratorCompanies, integratorId } = this.props;
    getIntegratorCompanies({
      id: integratorId,
      page: state.page,
      limit: state.numberOfRows,
    });
  }

  render() {
    let { companies, page, total, numberOfRows } = this.props;
    let { rowsPerPage, filter, autocomplete } = this.state;
    const { updateFilter, updateRows } = this;
    if (filter.length > 0) {
      companies = companies.filter((c) => {
        const name = String(c.name).toLowerCase();
        const ownerEmail = String(c.owner.email);
        let f = filter.toLowerCase();
        return (
          name.includes(f) ||
          ownerEmail.includes(f) ||
          c.members.some((member) => String(member.email).includes(f))
        );
      });
    }

    if (companies.length < 1 && filter.length < 1) {
      return (
        <div className="container-fluid text-center">
          <h5>Integrator has no companies.</h5>
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <AutoComplete
              animated
              hintText="Enter company name or user's email"
              dataSource={autocomplete}
              filter={(searchText, key) => searchText !== '' && key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1}
              onUpdateInput={updateFilter}
              textFieldStyle={{ width: "300px" }}
            />

            <Pagination
              total={total}
              rowsPerPage={rowsPerPage}
              page={page}
              numberOfRows={numberOfRows}
              updateRows={updateRows}
            ></Pagination>
          </div>
        </div>
        <div className="row">
          <div className="table-body">
            <Table selectable={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Email of company
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Company name
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Name, surname of owner
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Email of owner
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    Emails of members
                  </TableHeaderColumn>

                  <TableHeaderColumn style={styles.tableRowBorderedTop}>
                    API limits (used)
                  </TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {companies.map((item) => (
                  <CompanyRow key={item._id || item.name} item={item} />
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ integratorCompanies }) => ({
    companies: integratorCompanies.data,
    page: integratorCompanies.page,
    integratorId: integratorCompanies.integratorId,
    total: integratorCompanies.total || 0,
    numberOfRows: integratorCompanies.limit,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        getIntegratorCompanies,
      },
      dispatch
    )
)(IntegratorCompaniesTable);



// WEBPACK FOOTER //
// ./app/components/Integrators/Companies/Table.jsx